import styled from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';
import Text from '@atoms/Text/Text';
import Heading from '@atoms/Heading/Heading';

export const StyledHeading = styled(Heading)`
  margin-bottom: ${rem(16)};
  margin-top: ${rem(16)};
`;

export const StyledDescription = styled(Text)`
  margin-bottom: ${rem(24)};
  text-align: left;
`;

export const StyledButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
`;

export const StyledFlyerOption = styled.button<{ $disabled?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${rem(16)};
  padding: ${rem(16)};
  border: ${rem(1)} solid ${variables.colors.mediumGray};
  border-radius: ${rem(4)};
  background: none;
  width: 100%;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};

  &:hover:not(:disabled) {
    border-color: ${variables.colors.highlight};
    box-shadow: inset 0 0 0 ${rem(1)} ${variables.colors.highlight};
  }

  &:focus-visible {
    outline: ${rem(2)} solid ${variables.colors.highlight};
    outline-offset: ${rem(2)};
  }
`;

export const StyledFlyerOptionText = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;
